var BatteryStatus;
(function (BatteryStatus) {
    BatteryStatus["LOW"] = "LOW";
    BatteryStatus["MEDIUM"] = "MEDIUM";
    BatteryStatus["HIGH"] = "HIGH";
    BatteryStatus["FULL"] = "FULL";
    BatteryStatus["NONE"] = "NONE";
})(BatteryStatus || (BatteryStatus = {}));
export default BatteryStatus;
